import React from "react";

export default function Card({ children, style = {}, ...props }) {
  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 16,
        boxShadow: "0 2px 8px rgba(44, 39, 56, 0.06)",
        padding: 16,
        marginBottom: 16,
        ...style,
      }}
      {...props}
    >
      {children}
    </div>
  );
}
